import { config } from '../config.js'

const emptyPir = {
  additionalRecipients: [],
  requestorInformation: {
    additionalName: '',
    confirmEmail: '',
    email: '',
    phone: '',
    address: '',
    lastName: '',
    firstName: '',
    brokerageName: '',
    isRealtor: undefined
  },
  strataInformation: {
    additionalName: '',
    confirmEmail: '',
    email: '',
    phone: '',
    address: '',
    lastName: '',
    firstName: '',
    role: '',
    strataNumber: ''
  },
  ownerInformation: {
    ownedBy: 'person',
    companyName: '',
    signatureSource: '',
    signatureFile: undefined,
    firstName: '',
    lastName: '',
    address: '',
    phone: '',
    email: '',
    confirmEmail: ''
  },
  propertyInformation: {
    address: '',
    city: config.city,
    province: config.pir.province,
    postalCode: '',
    unit: ''
  }
}

const pirStepperArray = ['Request', 'Review', 'Payment']

function isPirPaymentEnabled() {
  return config.pir.paymentEnabled !== false
}

function getPirStepperArray(includePayment = isPirPaymentEnabled()) {
  if (includePayment) return pirStepperArray
  return pirStepperArray.slice(0, 2)
}

export { emptyPir, pirStepperArray, getPirStepperArray, isPirPaymentEnabled }
